import { render, staticRenderFns } from "./SolutionBase.vue?vue&type=template&id=546822d8&"
import script from "./SolutionBase.vue?vue&type=script&lang=js&"
export * from "./SolutionBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports